import React from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import config from "../../config";
import { useNavigate, useLocation } from "react-router-dom";
import { useDisconnect, useAccount } from "wagmi";
import toast from "react-hot-toast";

export default function Howitwork() {
  const navigate = useNavigate();
  const { address, isConnected } = useAccount();

  const sendToPresaleForm = () => {
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    }
    navigate(`${config.baseUrl}presaleForm`);
    window.scrollTo(0, 0);
  };

  const sendToSwapForm = () => {
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    }
    navigate(`${config.baseUrl}multichainSwapForm`);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <Header />
      <div className="bg-darkgrey">
        <section className="aboutus bgStar py-5 ">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center py-5">
                  <div
                    className="headingbox position-relative mb-3"
                    style={{ minHeight: "100px" }}
                  >
                    <div className="coins">
                      <img
                        src="images/coinsmall.png"
                        className="position-absolute start-0 bottom-0"
                        style={{ width: "70px" }}
                        alt=""
                      />
                      <img
                        src="images/coinlarge.png"
                        className="position-absolute end-0 top-0"
                        style={{ width: "90px" }}
                        alt=""
                      />
                    </div>
                    <Row className="justify-content-center">
                      <Col lg={9}>
                        <div className="position-relative d-inline-block text-left">
                          <div className="polygon" style={{ right: "30px" }}>
                            <img src="images/shape/polygon.png" alt="" />
                          </div>
                          <h1 className=" position-relative text-white">
                            INFI Staking & Participation&nbsp;-&nbsp;
                            <span className="fw-normal">
                              Monthly Distribution Based on Platform Activity
                            </span>
                          </h1>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="position-relative">
                    <p className="text-light-grey2">
                      Explore how INFI enables users to engage with
                      digital assets through storage, optional staking
                      features, and decentralized exchange tools—
                      seamlessly integrated within a blockchain-based
                      environment.
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg={12}>
                <div className="">
                  <div className="text-center position-relative mb-5">
                    <h2 className="text-white lh-sm mb-3">Staking Overview</h2>
                  </div>
                  <div>
                    <Card className="bg-transparent border-primary mb-5">
                      <Card.Body>
                        <Row>
                          <Col lg={3} className="">
                            <div className="">
                              <Card className="bg-transparent border-0 p-3 sameHeight text-center">
                                <div>
                                  <div className="fs-5 mb-3">✅</div>
                                  <h5 className="mb-3 text-white fw-normal">
                                    INFI Smart Contract Address
                                  </h5>
                                  <p className="text-light-grey2 mb-0">
                                    0x0CC9b5290d920bDC966E93205241D0eE07b5799f
                                  </p>
                                </div>
                              </Card>
                            </div>
                          </Col>
                          <Col lg={3} className="">
                            <div className="">
                              <Card className="bg-transparent border-0 p-3 sameHeight text-center">
                                <div>
                                  <div className="fs-5  mb-3">✅</div>
                                  <h5 className="mb-3 text-white fw-normal">
                                    Network
                                  </h5>
                                  <p className="text-light-grey2 mb-0">
                                    Polygon (MATIC)
                                  </p>
                                </div>
                              </Card>
                            </div>
                          </Col>
                          <Col lg={3} className="">
                            <div className="">
                              <Card className="bg-transparent border-0 p-3 sameHeight text-center">
                                <div>
                                  <div className="fs-5  mb-3">✅</div>
                                  <h5 className="mb-3 text-white fw-normal">
                                    Ownership
                                  </h5>
                                  <p className="text-light-grey2 mb-0">
                                    Renounced
                                  </p>
                                </div>
                              </Card>
                            </div>
                          </Col>
                          <Col lg={3} className="">
                            <div className="">
                              <Card className="bg-transparent border-0 p-3 sameHeight text-center">
                                <div>
                                  <div className="fs-5  mb-3">✅</div>
                                  <h5 className="mb-3 text-white fw-normal">
                                    Audit Report
                                  </h5>
                                  <div>
                                    <a href="#" className="text-primary2">
                                      View SolidProof Audit{" "}
                                    </a>
                                  </div>
                                </div>
                              </Card>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="createanaccount position-relative pb-5">
          <Container className=" position-relative">
            <Row className="justify-content-center align-items-center">
              <Col lg={12}>
                <div className="pb-5">
                  <div className="text-center position-relative mb-5 pb-3">
                    <h2 className="text-white lh-sm mb-3">How It Works</h2>
                  </div>
                  <div>
                    <div>
                      <Row>
                        <Col lg={4} className="mb-5">
                          <div className="cardStyle3">
                            <Card className="p-3 cardBox">
                              <div>
                                <div className="iconBox">
                                  <img
                                    src="images/icon/connect.png"
                                    class="infi-icon "
                                    alt=""
                                    style={{
                                      filter: "brightness(0) invert(1)",
                                    }}
                                  />
                                </div>
                                <h5 className="mb-3 text-white fw-normal">
                                  Connect & Register
                                </h5>
                                <div>
                                  <ul className="list-unstyled ps-0 mb-0">
                                    <li className="mb-2 text-light-grey2">
                                      ✅ Connect your wallet
                                    </li>
                                    <li className="mb-2 text-light-grey2">
                                      ✅ Register with your email
                                    </li>
                                    <li className="mb-2 text-light-grey2">
                                      ✅ Activate your account via the
                                      confirmation link
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </Card>
                          </div>
                        </Col>
                        <Col lg={4} className="mb-5">
                          <div className="cardStyle3">
                            <Card className="p-3 cardBox">
                              <div>
                                <div className="iconBox">
                                  <img
                                    src="images/icon/stake.png"
                                    class="infi-icon "
                                    alt=""
                                    style={{
                                      filter: "brightness(0) invert(1)",
                                    }}
                                  />
                                </div>
                                <h5 className="mb-3 text-white fw-normal">
                                  Stake INFI
                                </h5>
                                <div>
                                  <ul className="list-unstyled ps-0 mb-0">
                                    <li className="mb-2 text-light-grey2">
                                      ✅ Staking is available on the 26th, 27th,
                                      and 28th of each month
                                    </li>
                                    <li className="mb-2 text-light-grey2">
                                      ✅ Stake directly from your registered
                                      wallet address
                                    </li>
                                    <li className="mb-2 text-light-grey2">
                                      ✅ Ensure you hold MATIC (Polygon) to
                                      cover gas fees
                                    </li>
                                    <li className="mb-2 text-light-grey2">
                                      ✅ Minimum stake: 1 INFI
                                    </li>
                                    <li className="mb-2 text-light-grey2">
                                      ✅ Maximum stake: 12,000 INFI
                                    </li>
                                    <li className="mb-2 text-light-grey2">
                                      ✅ Each wallet can only stake once for a
                                      24-month period
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </Card>
                          </div>
                        </Col>
                        <Col lg={4} className="mb-5">
                          <div className="cardStyle3">
                            <Card className="p-3 cardBox ">
                              <div>
                                <div className="iconBox">
                                  <img
                                    src="images/icon/reward.png"
                                    class="infi-icon "
                                    alt=""
                                    style={{
                                      filter: "brightness(0) invert(1)",
                                    }}
                                  />
                                </div>
                                <h5 className="mb-3 text-white fw-normal">
                                  Access Participation Benefits
                                </h5>
                                <div>
                                  <ul className="list-unstyled ps-0 mb-0">
                                    <li className="mb-2 text-light-grey2">
                                      ✅ Distribution eligibility begins 30 days after
                                      your participation start date
                                    </li>
                                    <li className="mb-2 text-light-grey2">
                                      ✅ Users may access DAI allocations between
                                      the 1st and 25th of each month (subject to
                                      platform activity)
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              {/* <div>
                                <div className="iconBox">
                                  <img
                                    src="images/icon/reward.png"
                                    class="infi-icon "
                                    alt=""
                                    style={{
                                      filter: "brightness(0) invert(1)",
                                    }}
                                  />
                                </div>
                                <h5 className="mb-3 text-white fw-normal">
                                  Earn Rewards
                                </h5>
                                <div>
                                  <ul className="list-unstyled ps-0 mb-0">
                                    <li className="mb-2 text-light-grey2">
                                      ✅ Rewards begin 30 days after your
                                      staking date
                                    </li>
                                    <li className="mb-2 text-light-grey2">
                                      ✅ Claim USDT and BTC rewards between the
                                      1st and 25th of each month
                                    </li>
                                  </ul>
                                </div>
                              </div> */}
                            </Card>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    <Row>
                      <Col lg={12} className="mb-5">
                        <div className="cardStyle3">
                          <Card className="p-3 cardBox ">
                            <div>
                              <h5 className="mb-3 text-white fw-normal">
                                What You Need to Know
                              </h5>
                              <div>
                                <ul className="list-unstyled ps-0 mb-0">
                                  <li className="mb-2 text-light-grey2">
                                    <span className="text-white">✅ Unclaimed Rewards</span>
                                    <div>
                                      <p>Any unclaimed allocation will be <span className="text-white">automatically carried over to the following month,
                                      </span> ensuring no rewards are lost.</p>
                                    </div>
                                  </li>
                                  <li className="mb-2 text-light-grey2">
                                    <span className="text-white">✅ DAO Governance Participation</span>
                                    <div>
                                      <p>Only <span className="text-white">INFI token stakers</span> are eligible to participate in DAO governance processes <span className="text-white">without any
                                        additional platform fees.</span> Please note: minimal <span className="text-white">blockchain-native tokens</span> (e.g., ETH, MATIC,
                                        BNB) may be required to cover gas fees on respective chains.</p>
                                    </div>
                                  </li>
                                  <li className="mb-2 text-light-grey2">
                                    <span className="text-white">✅ Cryptocurrency-Based Rewards</span>
                                    <div>
                                      <p>All rewards will be distributed <span className="text-white">exclusively in cryptocurrencies</span> such as <span className="text-white">USDT or DAI,</span> derived
                                        from the <span className="text-white">fees accumulated by the SbSe Protocol</span> during actual platform usage. No fiat or offchain payouts will be provided.</p>
                                    </div>
                                  </li>
                                  <li className="mb-2 text-light-grey2">
                                    <span className="text-white">✅ Need Assistance?</span>
                                    <div>
                                      <p>Our support team is here to help! Feel free to contact us anytime at <span className="text-white">support@infimultichain.com.</span></p>
                                    </div>
                                  </li>
                                

                                </ul>
                              </div>

                              {/*<div>
                                <ol className=" mb-0">
                                  <li className="mb-2 text-light-grey2">
                                    Ensure your wallet contains MATIC to cover
                                    gas fees
                                  </li>
                                  <li className="mb-2 text-light-grey2">
                                    Rewards must be claimed monthly — they do
                                    not carry over automatically
                                  </li>
                                  <li className="mb-2 text-light-grey2">
                                    If you miss a month, contact
                                    support@infimultichain.com with your email
                                    and wallet address
                                  </li>
                                  <li className="mb-2 text-light-grey2">
                                    Warning: Without this info, we may not be
                                    able to assist you
                                  </li>
                                </ol>
                              </div> */}
                            </div>
                          </Card>
                        </div>
                      </Col>
                      {/* <Col lg={6} className="mb-5">
                        <div className="cardStyle3">
                          <Card className="p-3 cardBox">
                            <div>
                              <h5 className="mb-3 text-white fw-normal">
                                Important Policies
                              </h5>
                              <div>
                                <ol className=" mb-0">
                                  <li className="mb-2 text-light-grey2">
                                    10% fee may be deducted from unclaimed
                                    rewards and reallocated to the next month’s
                                    SbSe PFP pool.
                                  </li>
                                  <li className="mb-2 text-light-grey2">
                                    If rewards go unclaimed for 6 consecutive
                                    months, they will be forfeited and
                                    redistributed to active INFI stakers.
                                  </li>
                                  <li className="mb-2 text-light-grey2">
                                    Beware of scammers — our only official
                                    support email is:{" "}
                                    <a href="support@infimultichain.com">
                                      support@infimultichain.com
                                    </a>
                                  </li>
                                </ol>
                              </div>
                            </div>
                          </Card>
                        </div>
                      </Col> */}
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="createanaccount position-relative  mt-0 overflow-hidden pb-5">
          <Container className=" position-relative">
            <Row className="justify-content-center align-items-center">
              <Col lg={12}>
                <div className="">
                  {/* <div className="text-center position-relative mb-5">
                            <h2 className="text-white mb-3">Market Performance</h2>
                          </div> */}
                  <div>
                    <Card className="bg-transparent border-0 ">
                      <Card.Body>
                        <Row>
                          <Col lg={6} className="">
                            {/* <div className="ps-lg-5 pt-5">
                                      <h1 className="text-primary3 mb-3">$1.04554</h1>
                                      <h2 className="text-white mb-3">
                                        INFI Token Price:{" "}
                                        <span className="text-success">Live</span>
                                      </h2>
                                      <p className="text-light-grey mb-2 fs-4">
                                        Staking APY: 18–22%
                                      </p>
                                      <p className="text-light-grey fs-4">
                                        TVL (Total Value Locked): $42.6M+
                                      </p>
                                    </div> */}
                          </Col>
                          <Col lg={6} className="">
                            <div className="handblock">
                              <div className="handanimation">
                                <img
                                  src="images/handCoin.png "
                                  className="chain"
                                />

                                <img
                                  src="images/handImg.png"
                                  className="handImg"
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="readytoearn position-relative pb-5">
          <Container className=" position-relative">
            <Row className="justify-content-center align-items-center">
              <Col lg={12}>
                <div className="cardStyle4 mb-4">
                  <Card className="cardBox border-0 card">
                    <Card.Body>
                      <div className="py-5">
                        <div className="text-center position-relative mb-5">
                          <h1 className="text-white lh-sm mb-3">
                            Ready To Earn?
                          </h1>
                        </div>

                        <div className="text-center">
                          <Button
                            variant="custombtn"
                            className="rounded-5 px-4"
                            as={Link}
                            to="https://infimultichain.com/exch/"
                          >
                            Stake INFI Now
                          </Button>
                        </div>
                      </div>
                      <div className=" position-absolute bottom-0 start-0">
                        <img
                          src="images/shape/deepak.png"
                          width={`140px`}
                          alt=""
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="createanaccount position-relative pb-5">
          <Container className=" position-relative">
            <Row className="justify-content-center align-items-center">
              <Col lg={12}>
                <div className="">
                  <div className="text-center position-relative mb-5">
                    <h1 className="text-white lh-sm mb-3">
                      Automated Project Onboarding Services
                    </h1>
                    <p className="text-light-grey">
                      The INFI MultiChain CDEX Exchange offers complimentary onboarding tools
                      for blockchain-based projects across 14 networks, including Fantom, Aurora,
                      Cronos, ZigChain, Tron, Optimism, zkSync Era, Metis, Polygon, Avalanche,
                      Arbitrum, BNB Smart Chain, Ethereum, and Base. This streamlined and
                      automated setup is coordinated by the ©SbSe Protocol to support efficient
                      and decentralized participation.
                    </p>
                  </div>

                  <div>
                    <Row className="justify-content-center">
                      <Col lg={4} className="mb-5">
                        <div className="cardStyle3">
                          <Card className="p-3 cardBox mh-auto">
                            <div>
                              <h5 className="mb-3 text-white fw-normal">
                                Seamless Project Onboarding & Visibility Tools
                              </h5>
                              <div>
                                <p className="text-light-grey2">
                                  Bringing your blockchain project into the INFI MultiChain CDEX
                                  ecosystem is a streamlined, automated experience. The process is
                                  coordinated by the ©SbSe Protocol and supports decentralized token
                                  setup and network visibility across 14 supported chains — with <strong className="text-white fw-normal">no
                                    platform usage fee required from project teams.</strong>
                                </p>
                              </div>
                            </div>
                            <div>
                              <h5 className="mb-3 text-white fw-normal">
                                Adaptive Liquidity Coordination System

                              </h5>
                              <div>
                                <p className="text-light-grey2">
                                  Our new decentralized coordination model allows project creators to
                                  align token behavior with supported ecosystems using just <strong className="text-white fw-normal">10 INFI,</strong>
                                  without any ongoing charges. Tokens can be integrated into the SbSe
                                  AMM structure, enhancing overall activity and accessibility across the
                                  platform’s supported environments.
                                </p>
                              </div>
                            </div>
                          </Card>
                        </div>
                      </Col>
                      <Col lg={4} className="mb-5">
                        <div className="cardStyle3">
                          <Card className="p-3 cardBox mh-auto">
                            <div>
                              <h5 className="mb-3 text-white fw-normal">
                                Dynamic Liquidity Coordination & User-Focused
                                Safeguards
                              </h5>
                              <div>
                                <p className="text-light-grey2">
                                  The INFI MultiChain CDEX Exchange includes an optional liquidity
                                  coordination mechanism designed to help stabilize token movement across
                                  supported pools. A dedicated SbSe Reserve structure provides a <strong className="text-white fw-normal">48-hour
                                    event response window,</strong> offering a community-managed review process
                                  for irregular activity. This aims to support a more consistent and resilient
                                  platform environment.
                                </p>
                              </div>
                            </div>
                            <div>
                              <h5 className="mb-3 text-white fw-normal">
                                Community Voting Pools
                              </h5>
                              <div>
                                <p className="text-light-grey2 mb-1">
                                  Starting in Q3-Q4 2025, INFI holders will have
                                  the ability to participate in community-driven
                                  voting to decide on key project matters,
                                  including:
                                </p>
                                <ul className="text-light-grey2 ps-3 mb-0">
                                  <li>Marketing strategies</li>
                                  <li>Investment decisions</li>
                                  <li>Liquidity management</li>
                                  <li>Collaborations and partnerships</li>
                                </ul>
                              </div>
                            </div>
                          </Card>
                        </div>
                      </Col>
                      <Col lg={4} className="mb-5">
                        <div className="cardStyle3">
                          <Card className="p-3 cardBox mh-auto">
                            <div>
                              <h5 className="mb-3 text-white fw-normal">
                                Smart Watch Account – Adaptive Security Monitoring
                              </h5>
                              <div>
                                <p className="text-light-grey2">
                                  The Smart Watch Account integrates with independent third-party
                                  monitoring tools and blockchain analytics services to observe and evaluate
                                  unusual patterns in activity. This adds an additional layer of transparency
                                  and operational integrity for platform participants.
                                </p>
                              </div>
                            </div>
                            <div>
                              <h5 className="mb-3 text-white fw-normal">
                                Retain Full Control of Your Digital Assets
                              </h5>
                              <div>
                                <p className="text-light-grey2 mb-1">
                                  <strong className="text-white">
                                    INFI MultiChain CDEX Exchange
                                  </strong>{" "}
                                  does not hold any digital assets, allowing you
                                  to maintain full control over your investments
                                  at all times.
                                </p>
                              </div>
                            </div>
                          </Card>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="text-center">
                    <Button
                      variant="default"
                      className="btn-white-gradient text-black px-4 rounded-5 position-relative z-2 me-sm-3 mb-3"
                      onClick={sendToPresaleForm}
                    >
                      RAISE A FUND&nbsp;&nbsp;&nbsp;
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="16"
                        viewBox="0 0 24 19"
                        fill="none"
                      >
                        <path
                          d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Button>
                    <Button
                      className="px-4 rounded-5 bg-black  position-relative z-2  border mb-3"
                      onClick={sendToSwapForm}
                      disabled
                    >
                      List Your Project&nbsp;&nbsp;&nbsp;
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="16"
                        viewBox="0 0 24 19"
                        fill="none"
                      >
                        <path
                          d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="orderbook-swap-section pt-5 pb-5">
          <Container>
            <Row>
              <Col lg={12}>
                <h2 className="fw-bold mb-3 text-white bg-head">
                  SbSe OrderBook Swap : Advanced Peer-Matching Across Networks
                </h2>
                <p className="text-light-grey2">
                  The SbSe OrderBook Swap provides a streamlined, buy-only peer-matching experience
                  across 14 blockchain networks. Supporting over 53 widely used digital assets, it enables
                  seamless, discreet interaction with digital resources through the ©SbSe Protocol.
                </p>

                <h4 className="fw-semibold mt-4 mb-2 text-white">
                  Key Features and Highlights:
                </h4>
                <ul className="text-light-grey2">
                  <li>
                    <strong className="text-white">
                      Cross-Network Compatibility :
                    </strong>{" "}
                    Accessible across 14 major blockchains, offering a
                    broad array of supported digital assets.

                  </li>
                  <li>
                    <strong className="text-white">
                      Enhanced Peer Connection :
                    </strong>{" "}
                    Facilitates well-coordinated exchanges via the ©SbSe
                    Protocol’s decentralized logic layer.
                  </li>
                  <li>
                    <strong className="text-white">
                      Exclusive Access Rates :
                    </strong>{" "}
                    Enables reduced exchange levels for selected digital assets
                    through on-chain parameters.
                  </li>
                  <li>
                    <strong className="text-white">
                      Minimal Usage Fees :
                    </strong>{" "}
                    Protocol-driven conditions allow users to engage with
                    exceptionally low or zero on-chain expense levels.
                  </li>
                  <li>
                    <strong className="text-white">
                      Platform-Based Incentives :
                    </strong>{" "}
                    Participants may receive optional network credits in
                    stable-value assets based on protocol usage.
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="Security position-relative pt-0 pb-0">
          <Container className="pb-5 position-relative">
            <Row className="justify-content-center align-items-center py-2">
              <Col lg={12} className="pb-5 security-card">
                <div className="bookshap">
                  <img src="images/book.png" alt="" />
                </div>
                <Card className="bg-transparent border border-dark p-5">
                  <Row className="justify-content-center">
                    <Col xl={12} lg={10}>
                      <div className="security-detail p-md-5 pt-5">
                        <h2 className="text-white mb-4 text-center">
                          Leveraging the{" "}
                          <span className="text-primary-gradient">
                            ©SbSe Protocol,
                          </span>{" "}
                          INFI establishes a transparent, decentralised and
                          community-driven financial infrastructure, setting a
                          new standard for innovation in the blockchain space.
                        </h2>
                      </div>
                      <div className="buyInfi">
                        <Button
                          variant="default"
                          className="btn-white-gradient fw-bold text-black px-4 rounded-5 position-relative z-2 me-sm-3"
                          onClick={sendToPresaleForm}
                        >
                          RAISE A FUND&nbsp;&nbsp;&nbsp;
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="16"
                            viewBox="0 0 24 19"
                            fill="none"
                          >
                            <path
                              d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Button>
                        <Button
                          className="px-4 rounded-5 bg-black  position-relative z-2 me-sm-3 border"
                          onClick={sendToSwapForm}
                          disabled
                        >
                          List Your Project&nbsp;&nbsp;&nbsp;
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="16"
                            viewBox="0 0 24 19"
                            fill="none"
                          >
                            <path
                              d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                              stroke="white"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Button>
                        <Button
                          variant="custombtn"
                          className="text-black px-4 rounded-5 position-relative z-2 text-uppercase"
                        >
                          <div className="d-flex gap-2 align-items-center">
                            <div className="lh-1">
                              SbSe OTC OrderBook
                              <div className="text-success text-uppercase x-small">
                                (Coming soon)
                              </div>
                            </div>
                            <div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="16"
                                viewBox="0 0 24 19"
                                fill="none"
                              >
                                <path
                                  d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                                  stroke="black"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                          </div>
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Container>
          <div className="bg-shape3 ">
            <img src="images/bg-shape3.png" alt="" />
          </div>
        </section>
        <section className="pb-5 mb-5">
          <Container className="pb-5">
            <Row>
              <Col lg={12}>
                <div className="text-white">
                  <h3 className="text-white bg-head">
                    SbSe Instant Swap – Fast, Secure, and Decentralized
                  </h3>
                  <p>
                    SbSe Instant Swap offers a seamless and user-directed experience for exchanging
                    digital assets across 14 integrated blockchain networks. Users can interact with a
                    wide selection of digital tokens while benefiting from optional stable-value credits
                    based on usage activity.
                  </p>
                  <p>
                    As part of the broader decentralized framework, SbSe Instant Swap functions
                    under the logic and automation of the SbSe Protocol. This self-operating system is
                    built to prioritize performance, security, and ecosystem-level coordination—
                    supporting a transparent, user-first digital environment.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Footer />
    </>
  );
}
